var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['search-card', {
    'selected': _vm.isSelected,
  }],on:{"click":_vm.onClick}},[_c('div',{staticClass:"inner-card"},[_c('img',{staticClass:"card-icon-cat",attrs:{"src":_vm.iconSrc,"alt":"Entertainment Icon"}}),_c('p',{staticClass:"card-title-cat"},[_vm._v(_vm._s(_vm.displayLabel))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }